/* eslint-disable no-case-declarations */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import metadata from './MLPUPBusinessActivitiesComponent.metadata.json5';
import './MLPUPBusinessActivitiesComponent.messages';

// Component is only shown in read only
function MLPUPBusinessActivitiesComponent(props) {
    const {
        items,
        getTypeKeyDescription,
        isModernProduct
    } = props;

    const viewModelService = useContext(ViewModelServiceContext);
    const businessTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('PUPBusinessType_PUE');
    const businessClassTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('PUPBusinessClass_PUE');

    const generateItemOverrides = () => {
        const itemOverrides = items.map((item, itemIndex) => {
            if(isModernProduct) {
                return {
                [`coverageTypeContent${itemIndex}`]: {
                    content: getTypeKeyDescription(businessClassTypelist.getCode(item.businessClass).name)
                }
                };
            } else {
                return {
                [`coverageTypeContent${itemIndex}`]: {
                    content: getTypeKeyDescription(businessTypelist.getCode(item.businessType).name)
                }
                };
            }
        });

        return Object.assign({}, ...itemOverrides);
    };

    const overrides = {
        tableRowIterable: {
            data: items
        },
        ...generateItemOverrides()
    };
    const resolvers = {};

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLPUPBusinessActivitiesComponent.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getTypeKeyDescription: PropTypes.func.isRequired
};

export default MLPUPBusinessActivitiesComponent;
